<template>
    <v-container fluid>
        <v-toolbar
        color="secondary"
        dark
        >
            <v-toolbar-title>Part of the following cases:</v-toolbar-title>
        </v-toolbar>
          <v-card flat>
                <CaseListLite
                sort="Most Popular"
                :isPublic="true"
                :pageSize="10"
                :uid="userDb.uid"
                currentCollectionSelected="All"></CaseListLite>
          </v-card>
    </v-container>
</template>

<script>
import CaseListLite from './../CaseList/CaseListLite.vue'
import TreatmentDataService from './../../../services/treatmentDataService.js'

export default {
    data () {
      return {
        treatmentService: null,
      }
    },
    props: {
        caseIds: Array,
        userDb: Object
    },
    components: {
        CaseListLite
    },
    computed: {
        getCategoryType(){
            return this.category;
        }
    },
    beforeCreate() {
        this.$options.components.CaseListLite = require('./../CaseList/CaseListLite.vue').default
    },
    mounted(){
        this.load();
    },
    methods: {
        async load(){
            //First initialise the data service
            this.treatmentService = new TreatmentDataService(this.userDb);

        }
    },
}
</script>